var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6.708,
    height: 6.708,
    viewBox: "0 0 6.708 6.707",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.805 0.153)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_167075",
    "data-name": "Path 167075",
    d: "M-15564.918,6672.818l6,6",
    transform: "translate(15564.468 -6672.618)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_167076",
    "data-name": "Path 167076",
    d: "M-15558.918,6672.818l-6,6",
    transform: "translate(15564.467 -6672.618)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXIcon);
export default __webpack_public_path__ + "static/media/x-icon.3354233ec08f13e59e25832cd86e656e.svg";
export { ForwardRef as ReactComponent };